import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import qs from 'qs';
import { format } from '@/@core/utils/string';
import { inject, injectable } from 'inversify';
import { HTTP_BATCH_TIMEOUT } from './variable';
import { Symbols } from '../../symbols';
let AccountApi = class AccountApi {
    constructor(http, urls, boHelperService, passportPublicUrls) {
        this.http = http;
        this.urls = urls;
        this.boHelperService = boHelperService;
        this.passportPublicUrls = passportPublicUrls;
        /**
         * 添加试用
         */
        this.postAccountPrivilegeTrial = (params) => {
            const url = this.urls.postAccountPrivilegeTrial;
            params = {
                ...params,
                bop_account_pojos: _.map(params.bop_account_pojos, row => {
                    row = this.boHelperService.maybeSerializeBeginDate(row, 'begin_at_value');
                    row = this.boHelperService.maybeSerializeEndDate(row, 'end_at_value');
                    return row;
                }),
            };
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
        * 添加试用前的校验
        */
        this.postAccountPrivilegeTrialCheck = (params) => {
            const url = this.urls.postAccountPrivilegeTrialCheck;
            params = {
                ...params,
                bop_account_pojos: _.map(params.bop_account_pojos, row => {
                    row = this.boHelperService.maybeSerializeBeginDate(row, 'begin_at_value');
                    row = this.boHelperService.maybeSerializeEndDate(row, 'end_at_value');
                    return row;
                }),
            };
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
         * 批量添加试用check
         */
        this.postAccountPrivilegeTrialBatchCheck = (params) => {
            const url = this.urls.postAccountPrivilegeTrialBatchCheck;
            params = this.boHelperService.maybeSerializeBeginDate(params, 'begin_at_value');
            params = this.boHelperService.maybeSerializeEndDate(params, 'end_at_value');
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
         * 批量添加试用
         */
        this.postAccountPrivilegeTrialBatch = (params) => {
            const url = this.urls.postAccountPrivilegeTrialBatch;
            params = this.boHelperService.maybeSerializeBeginDate(params, 'begin_at_value');
            params = this.boHelperService.maybeSerializeEndDate(params, 'end_at_value');
            return this.http.post({
                url,
                data: params,
            });
        };
        this.getTrialDaysLimitation = () => {
            const url = this.urls.getTrialDaysLimitation;
            return this.http.get({
                url,
            });
        };
        this.getCompanyFakeActiveUsers = (company_id) => {
            const url = format(this.urls.getCompanyFakeActiveUsers, {
                company_id,
            });
            return this.http.get({
                url,
            });
        };
        this.getAccountProducts = (params) => {
            const url = this.urls.getAccountProducts;
            return this.http.get({
                url,
                params,
            });
        };
        /**
         * 用户 设置
         */
        this.putAccountsSetting = (params) => {
            const url = this.urls.putAccountsSetting;
            return this.http.put({
                url,
                data: params,
            });
        };
        /** 获取用户产品权限列表 */
        this.getAccountProductPrivilege = (account_id) => {
            const url = format(this.urls.getAccountProductView, { account_id });
            return this.http.get({
                url,
            });
        };
        this.getTenantUsersPrivilegeView = (params) => {
            const url = this.urls.getTenantUsersPrivilegeView;
            return this.http.get({
                url,
                params,
            });
        };
        this.updateAccountPrivilegeExcludeFeatures = (data) => {
            return this.http.put({
                url: this.urls.putAccountPrivilegeExcludeFeatures,
                data,
            });
        };
        /** 用户系统限制 */
        this.getSystemLimit = (account_id) => {
            const url = format(this.urls.getSystemLimit, { account_id });
            return this.http.get({
                url,
            });
        };
        this.patchSystemLimit = (params) => {
            const url = this.urls.patchSystemLimit;
            return this.http.patch({
                url,
                data: params,
            });
        };
        //  编辑角色
        this.postTenantUserBatchJobRole = (data) => {
            const url = this.urls.postTenantUserBatchJobRole;
            return this.http.post({
                url,
                data: data,
            });
        };
        this.getPublicKeyApi = () => {
            const url = this.passportPublicUrls.getPublicKey;
            return this.http.get({
                url,
            });
        };
        // 删除或撤销删除个人租户
        this.putTenantUsersIndividual = (params) => {
            const url = format(this.urls.putTenantUsersIndividual, params);
            return this.http.put({
                url,
            });
        };
    }
    preLogin(params) {
        const url = this.passportPublicUrls.preLogin;
        return this.http.post({
            url,
            withCredentials: true,
            data: {
                ...params,
                client_id: process.env.VUE_APP_PASSPORT_CLIENT_ID,
                authc_type: 'ACCOUNT_PASSWORD',
            },
        });
    }
    getMfaCk() {
        const url = this.passportPublicUrls.getMfaCk;
        return this.http.get({
            url,
            withCredentials: true,
        });
    }
    getCurrentUser() {
        return this.http.request({
            url: this.urls.getCurrentUser,
            isAuthorizationCache: true,
        });
    }
    postAddAccountPrivilege(params) {
        return this.http.post({
            url: this.urls.postAddAccountPrivilege,
            data: params,
        });
    }
    deleteAccountPrivilege(params) {
        const url = format(this.urls.deleteAccountPrivilege, params);
        return this.http.delete({
            url,
        });
    }
    deleteAccountPrivilegeTrial(params, accountPrivilegeId) {
        const url = format(this.urls.deleteAccountPrivilegeTrial, params);
        return this.http.delete({
            url,
            params: { accountPrivilegeId },
        });
    }
    /**
     *列举查询用户列表
     */
    splitParamsAndBody(params) {
        const { sales_emails, account_type_list, account_status_list, ...otherParams } = params;
        const data = _.pickBy({
            sales_emails,
            account_type_list,
            account_status_list,
        }, (value) => !_.isEmpty(value));
        return {
            params: otherParams,
            data,
        };
    }
    getListAccounts(params) {
        const url = this.urls.listAccounts;
        return this.http.post({
            url,
            ...this.splitParamsAndBody(params),
        });
    }
    postTenantUsersPagination(params) {
        const { sales_emails, account_type_list, account_status_list, ...otherParams } = params;
        const url = this.urls.postTenantUsersPagination;
        const data = _.pickBy({
            sales_emails,
            account_type_list,
            account_status_list,
        }, (value) => !_.isEmpty(value));
        return this.http.post({
            url,
            params: otherParams,
            data,
        });
    }
    /**
     * 获取用户具体信息
     */
    getAccountDetail(account_id) {
        const url = format(this.urls.getAccountDetail, {
            account_id,
        });
        return this.http.get({
            url,
            uuid: url,
        });
    }
    patchAccountsBatchEdit(params) {
        const url = this.urls.patchAccountsBatchEdit;
        return this.http.patch({
            url,
            data: params,
            timeout: HTTP_BATCH_TIMEOUT,
        });
    }
    patchAccountActivation(accountId) {
        const url = this.urls.patchAccountActivation;
        return this.http.patch({
            url,
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            data: qs.stringify({ accountId }),
            method: 'PATCH',
        });
    }
    patchUpdatePassword(account_id, params) {
        const url = format(this.urls.patchUpdatePassword, {
            account_id,
        });
        return this.http.patch({
            url,
            params,
        });
    }
    getSimpleAccountInfoView(account_id) {
        const url = this.urls.getSimpleAccountInfoView;
        return this.http.get({
            url,
            params: { account_id },
        });
    }
    getAccountBasic(account_id) {
        const url = this.urls.getAccountBasic;
        return this.http.get({
            url,
            params: { account_id },
        });
    }
    patchAccountUnlock(account_id) {
        const url = format(this.urls.patchAccountUnlock, {
            account_id,
        });
        return this.http.patch({ url });
    }
    patchAccountEdit(params) {
        const url = this.urls.patchAccountEdit;
        return this.http.patch({
            url,
            data: params,
        });
    }
    getAccountSendEmail(account_id) {
        const url = format(this.urls.getAccountSendEmail, {
            account_id,
        });
        return this.http.get({ url });
    }
    postSendEmailBatch(data) {
        const url = this.urls.postSendEmailBatch;
        return this.http.post({
            url,
            data,
        });
    }
    postIPRestrictBatchEdit(data) {
        const url = this.urls.postIPRestrictBatchEdit;
        return this.http.post({
            url,
            data,
        });
    }
    getIdentifyToken() {
        const url = this.urls.getIdentifyToken;
        return this.http.get({
            url,
        });
    }
    postRelieveSsoBinding(data) {
        const url = this.urls.postRelieveSsoBinding;
        return this.http.post({
            url,
            data,
        });
    }
    postRelieveSocialBinding(data) {
        const url = this.urls.postRelieveSocialBinding;
        return this.http.post({
            url,
            data,
        });
    }
    deleteInnoCloudBinding(user_id) {
        const url = this.urls.deleteInnoCloudBinding;
        return this.http.delete({
            url,
            params: {
                user_id,
            },
        });
    }
    postBeisenAccountByEmails(emails) {
        const url = this.urls.postBeisenAccountByEmails;
        return this.http.post({
            url,
            data: emails,
        });
    }
    getAccountBatchInfoSummary(accountIds) {
        const url = this.urls.getAccountBatchInfoSummary;
        return this.http.get({
            url,
            params: {
                account_id: accountIds.join(','),
            },
        });
    }
    postAccountBind(data) {
        const url = this.urls.postAccountBind;
        return this.http.post({
            url,
            data,
        });
    }
    postAccountAudit(params) {
        const url = this.urls.postAccountAudit;
        return this.http.post({
            url,
            params,
        });
    }
    getAccountTenants(account_id) {
        const url = format(this.urls.getAccountTenants, { account_id });
        return this.http.get({
            url,
        });
    }
    getTenantsUsersBasic(params) {
        const url = this.urls.getTenantsUsersBasic;
        return this.http.get({
            url,
            params,
        });
    }
    getTenantUserView(userId) {
        const url = format(this.urls.getTenantUserView, { userId });
        return this.http.get({
            url,
            params: { contain_credits_privilege: true },
        });
    }
    /**
     * 单个或批量伪激活
     */
    postTenantUserBatchFakeActive(data) {
        const url = this.urls.postTenantUserBatchFakeActive;
        return this.http.post({
            url,
            data,
        });
    }
    /**
     * 移除disabled
     */
    postTenantUserBatchDisable(data) {
        const url = this.urls.postTenantUserBatchDisable;
        return this.http.post({
            url,
            data,
        });
    }
    getTenantUsersSettingBasic(params) {
        const url = this.urls.getTenantUsersSettingBasic;
        return this.http.get({
            url,
            params,
        });
    }
    deleteMfaUnbind(userId) {
        const url = format(this.urls.deleteMfaUnbind, { userId });
        return this.http.delete({
            url,
        });
    }
    // 禁用解禁
    patchAccountsBlock(data) {
        const url = this.urls.patchAccountsBlock;
        return this.http.patch({
            url,
            data,
        });
    }
    patchAccountsUnblock(data) {
        const url = this.urls.patchAccountsUnblock;
        return this.http.patch({
            url,
            data,
        });
    }
    // 获取用户租户信息列表
    getTenantUsersList(account) {
        const url = this.urls.getTenantUsersList;
        return this.http.get({
            url,
            params: {
                email_or_mobile: account,
            },
        }).catch(e => {
            console.log(e);
        });
    }
    exportUsers(params) {
        return this.http.request({
            url: this.urls.exportUsers,
            method: 'post',
            responseType: 'blob',
            rawResponse: true,
            ...this.splitParamsAndBody(params),
        }).catch(async (err) => {
            // Blob 但是返回了JSON错误
            const isJsonBlob = (data) => data instanceof Blob && data.type === 'application/json';
            if (isJsonBlob(err.response?.data)) {
                const txt = await (err.response?.data)?.text();
                err.response.data = (typeof txt === 'string') ? JSON.parse(txt) : txt;
            }
            throw err;
        });
    }
    /**
     * 获取账号登录历史记录
     * @param params 查询参数
     * @returns 登录历史记录数据
     */
    getLoginHistory(params) {
        return this.http.request({
            method: 'GET',
            url: this.urls.getLoginHistory,
            params,
        });
    }
};
AccountApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.AccountApiUrls)),
    __param(2, inject(Symbols.BoHelperService)),
    __param(3, inject(Symbols.PassportPublicUrls)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], AccountApi);
export { AccountApi };
